import { umTag, errors } from '@/services';
export default {
	namespaced: true,
	state: {
		tagList: [],
	},
	getters: {
		enableTagList(st) {
			return st.tagList.filter((e) => e.status == 1);
		},
	},
	mutations: {
		setTagList(state, payload) {
			state.tagList = payload;
		},
	},
	actions: {
		async getTagList({ commit }) {
			try {
				const { ok, data } = await umTag.getTotalTagList();
				if (!ok) {
					return;
				}
				commit('setTagList', data.data);
			} catch (err) {
				errors(err);
			}
		},
	},
};
